import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  setDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import {
  Modal,
  Button,

  Form,
  Card,
  Row,
  Col,
  Container,
  Spinner,
} from "react-bootstrap";
import Swal from "sweetalert2";
import Sidebar from './Sidebar';
import { db } from "../firebase";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaEdit,
  FaPlus,
  FaPiggyBank,
  FaWallet,
  FaChartLine,
  FaCalendarCheck
} from "react-icons/fa";

const EventPage = () => {
  const [events, setEvents] = useState([]);
  const [newEvent, setNewEvent] = useState({
    title: "",
    description: "",
    date: new Date().toISOString().split("T")[0],
    location: "",
    amount: "",
  });
  const [showModal, setShowModal] = useState(false);
//   const [finesData, setFinesData] = useState([]);
  const [reload, setReload] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editEventId, setEditEventId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
//   const [viewMode, setViewMode] = useState("cards"); // "cards" or "table"

  const [fineAmountSummary, setFineAmountSummary] = useState({
    collectedAmount: 0,
    usedAmount: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch events
        const eventSnapshot = await getDocs(collection(db, "Events"));
        const eventData = eventSnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => new Date(a.date) - new Date(b.date));
        setEvents(eventData);

        // Fetch fines
        const finesCollection = collection(db, "Fines");
        const usersSnapshot = await getDocs(finesCollection);
        const data = [];

        for (const userDoc of usersSnapshot.docs) {
          const userId = userDoc.id;
          const userFinesCollection = collection(db, "Fines", userId, "fines");
          const finesSnapshot = await getDocs(userFinesCollection);

          const fines = finesSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          const totalFine = userDoc.data().TotalFine || 0;
          const pendingFine = userDoc.data().PendingFine || 0;
          const collectedFine = totalFine - pendingFine;

          const userInfoDoc = await getDoc(doc(db, "users", userId));
          const userName = userInfoDoc.exists()
            ? userInfoDoc.data().userName || "Unknown User"
            : "Unknown User";

          if (collectedFine > 0) {
            data.push({
              userId,
              userName,
              fines: fines.filter((fine) => fine.status === "Paid"),
              totalFine,
              pendingFine,
              collectedFine,
            });
          }
        }

        // setFinesData(data);

        const docRef = doc(db, "fineAmountHistory", "latest");
        const docSnap = await getDoc(docRef);

        let collectedAmount = 0;
        let usedAmount = 0;

        if (docSnap.exists()) {
          const data = docSnap.data();
          collectedAmount = data.collectedAmount || 0;
          usedAmount = data.usedAmount || 0;
        }

        setFineAmountSummary({ collectedAmount, usedAmount });
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "Failed to load data", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [reload]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddOrUpdateEvent = async (e) => {
    e.preventDefault();
    const action = isEditMode ? "Update" : "Add";

    const result = await Swal.fire({
      title: `${action} Event?`,
      text: `Do you want to ${action.toLowerCase()} this event?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${action}`,
      confirmButtonColor: "#3085d6",
    });

    if (result.isConfirmed) {
      try {
        const eventId = isEditMode
          ? editEventId
          : doc(collection(db, "Events")).id;
        // Always save amount as a number, default to 0 if invalid/empty
        const eventToSave = { ...newEvent, amount: parseFloat(newEvent.amount) || 0 };
        await setDoc(doc(db, "Events", eventId), eventToSave);
        Swal.fire({
          title: "Success!",
          text: `Event ${isEditMode ? "updated" : "added"} successfully!`,
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
        });
        setNewEvent({
          title: "",
          description: "",
          date: new Date().toISOString().split("T")[0],
          location: "",
          amount: "",
        });
        setShowModal(false);
        setReload(!reload);
        setIsEditMode(false);
        setEditEventId(null);

        // --- NEW LOGIC: usedAmount = sum of all events' amount when adding new event ---
        if (!isEditMode) {
          // Calculate total amount of all events (including the new one)
          const allEvents = [...events, { ...newEvent }];
          const totalUsedAmount = allEvents.reduce((sum, ev) => sum + (parseFloat(ev.amount) || 0), 0);
          const fineHistoryRef = doc(db, "fineAmountHistory", "latest");
          const fineHistorySnap = await getDoc(fineHistoryRef);
          if (fineHistorySnap.exists()) {
            const fineHistoryData = fineHistorySnap.data();
            await setDoc(fineHistoryRef, {
              ...fineHistoryData,
              usedAmount: totalUsedAmount,
            }, { merge: true });
          }
        }
        // --- END NEW LOGIC ---

        // --- NEW LOGIC: usedAmount = sum of all events' amount when editing event ---
        if (isEditMode) {
          // Calculate total amount of all events (replace the edited event with newEvent)
          const allEvents = events.map(ev => ev.id === editEventId ? { ...newEvent, id: editEventId } : ev);
          const totalUsedAmount = allEvents.reduce((sum, ev) => sum + (parseFloat(ev.amount) || 0), 0);
          const fineHistoryRef = doc(db, "fineAmountHistory", "latest");
          const fineHistorySnap = await getDoc(fineHistoryRef);
          if (fineHistorySnap.exists()) {
            const fineHistoryData = fineHistorySnap.data();
            await setDoc(fineHistoryRef, {
              ...fineHistoryData,
              usedAmount: totalUsedAmount,
            }, { merge: true });
          }
        }
        // --- END NEW LOGIC ---

      } catch (error) {
        console.error("Error saving event:", error);
        Swal.fire(
          "Error",
          `Could not ${isEditMode ? "update" : "add"} event`,
          "error"
        );
      }
    }
  };

  const handleEdit = (event) => {
    setNewEvent({ ...event, amount: parseFloat(event.amount) || 0 });
    setEditEventId(event.id);
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Event?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (result.isConfirmed) {
      try {
        await deleteDoc(doc(db, "Events", id));

        // --- NEW LOGIC: usedAmount = sum of all events' amount when deleting event ---
        // Remove the deleted event from the list
        const remainingEvents = events.filter((e) => e.id !== id);
        const totalUsedAmount = remainingEvents.reduce((sum, ev) => sum + (parseFloat(ev.amount) || 0), 0);
        const fineHistoryRef = doc(db, "fineAmountHistory", "latest");
        const fineHistorySnap = await getDoc(fineHistoryRef);
        if (fineHistorySnap.exists()) {
          const fineHistoryData = fineHistorySnap.data();
          await setDoc(fineHistoryRef, {
            ...fineHistoryData,
            usedAmount: totalUsedAmount,
            // collectedAmount: updatedCollected,
          }, { merge: true });
        }
        // --- END NEW LOGIC ---

        Swal.fire({
          title: "Deleted!",
          text: "Event has been deleted.",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
        });
        setReload(!reload);
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Could not delete event", "error");
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEditMode(false);
    setEditEventId(null);
    setNewEvent({
      title: "",
      description: "",
      date: new Date().toISOString().split("T")[0],
      location: "",
      amount: "",
    });
  };

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
    }).format(amount);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

//   const totalCollectedFines = finesData.reduce(
//     (sum, user) => sum + user.collectedFine,
//     0
//   );
//   const totalAllFines = finesData.reduce(
//     (sum, user) => sum + (user.totalFine || 0),
//     0
//   );
//   const totalPendingFines = finesData.reduce(
//     (sum, user) => sum + (user.pendingFine || 0),
//     0
//   );
//   const collectionRate = totalAllFines
//     ? Math.round(((totalAllFines - totalPendingFines) / totalAllFines) * 100)
//     : 0;

//   const upcomingEvents = events
//     .filter((e) => new Date(e.date) >= new Date())
//     .sort((a, b) => new Date(a.date) - new Date(b.date));
//   const pastEvents = events
//     .filter((e) => new Date(e.date) < new Date())
//     .sort((a, b) => new Date(b.date) - new Date(a.date));

  // Function to determine event status based on date
  const getEventStatus = (dateStr) => {
    const eventDate = new Date(dateStr);
    const today = new Date();
    
    // Calculate days difference
    const diffTime = eventDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return { text: "Completed", variant: "secondary" };
    if (diffDays === 0) return { text: "Today", variant: "danger" };
    if (diffDays <= 3) return { text: "Soon", variant: "warning" };
    return { text: "Upcoming", variant: "success" };
  };

  // Calculate available balance
  const availableBalance = fineAmountSummary.collectedAmount - fineAmountSummary.usedAmount;


  return (
<div className="bg-light min-vh-100" style={{ marginLeft: '250px' }}>
  <Container fluid className="py-4 px-4">
          <Sidebar />



        {/* Page Header */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 py-2 border-bottom">
          <div className="mb-3 mb-md-0">
            <h2 className="fw-bold text-primary mb-0">
              <FaCalendarCheck className="me-2" />
              Events Management
            </h2>
            <p className="text-muted mb-0">
            <b>  Manage your upcoming and past events </b>
            </p>
          </div>
          <div className="d-flex gap-2">
            
            <Button
              onClick={() => setShowModal(true)}
              className="btn btn-success d-flex align-items-center"
            >
              <FaPlus className="me-2" /> Add Event
            </Button>
          </div>
        </div>

        {isLoading ? (
          <div className="text-center my-5 py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3">Loading events data...</p>
          </div>
        ) : (
          <>
            {/* Stats Cards */}
            <Row className="mb-4">
              <Col md={4} className="mb-3">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
                        <FaPiggyBank className="text-primary fs-4" />
                      </div>
                      <div>
                        <h6 className="text-muted mb-1">Total Collected</h6>
                        <h4 className="mb-0 fw-bold">
                          {formatCurrency(fineAmountSummary.collectedAmount)}
                        </h4>
                      </div>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-primary"
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={4} className="mb-3">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-danger bg-opacity-10 p-3 rounded-circle me-3">
                        <FaWallet className="text-danger fs-4" />
                      </div>
                      <div>
                        <h6 className="text-muted mb-1">Amount Used</h6>
                        <h4 className="mb-0 fw-bold">
                          {formatCurrency(fineAmountSummary.usedAmount)}
                        </h4>
                      </div>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-danger"
                        style={{ width: `${fineAmountSummary.collectedAmount ? (fineAmountSummary.usedAmount / fineAmountSummary.collectedAmount) * 100 : 0}%` }}
                      ></div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={4} className="mb-3">
                <Card className="shadow-sm border-0 h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-success bg-opacity-10 p-3 rounded-circle me-3">
                        <FaChartLine className="text-success fs-4" />
                      </div>
                      <div>
                        <h6 className="text-muted mb-1">Available Balance</h6>
                        <h4 className="mb-0 fw-bold">
                          {formatCurrency(availableBalance)}
                        </h4>
                      </div>
                    </div>
                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-success"
                        style={{ width: `${fineAmountSummary.collectedAmount ? (availableBalance / fineAmountSummary.collectedAmount) * 100 : 0}%` }}
                      ></div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
<div className="row"> 
  <div className="col-12">
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Events</h5>
        <div>
          {isLoading && (
            <span
              className="spinner-border spinner-border-sm text-primary me-2"
              role="status"
            ></span>
          )}
         
          {/* <button
            className="btn btn-sm btn-success ms-2"
            onClick={() => setShowModal(true)}
          >
            <i className="bi bi-plus-circle me-1"></i>
            Add Event
          </button> */}
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-light">
              <tr>
                <th>Event</th>
                <th>Description</th>
                <th>Date</th>
                <th>Location</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.length > 0 ? (
                events.map((event) => {
                  const status = getEventStatus(event.date);
                  return (
                    <tr key={event.id}>
                      <td className="fw-bold">{event.title}</td>
                      <td>
                        {event.description.length > 50 
                          ? `${event.description.substring(0, 50)}...` 
                          : event.description}
                      </td>
                      <td>{formatDate(event.date)}</td>
                      <td>{event.location}</td>
                      <td>Rs. {parseFloat(event.amount).toFixed(2)}</td>
                      <td>
                        <span className={`badge bg-${status.variant}`}>
                          {status.text}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => handleEdit(event)}
                        >
                          <i className="bi bi-pencil me-1"></i>
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(event.id)}
                        >
                          <i className="bi bi-trash me-1"></i>
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    {isLoading ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading...
                        </span>
                      </div>
                    ) : (
                      <div className="text-muted">
                        <i className="bi bi-inbox fs-2 d-block mb-2"></i>
                        No events found
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
          </>
        )}

        {/* Event Modal */}
        <Modal show={showModal} onHide={handleCloseModal} centered backdrop="static">
          <Modal.Header closeButton className="bg-light">
            <Modal.Title>
              {isEditMode ? (
                <>
                  <FaEdit className="me-2 text-warning" />
                  Edit Event
                </>
              ) : (
                <>
                  <FaPlus className="me-2 text-success" />
                  Add New Event
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleAddOrUpdateEvent}>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Event Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={newEvent.title}
                  onChange={handleInputChange}
                  placeholder="Enter event title"
                  required
                  autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={newEvent.description}
                  onChange={handleInputChange}
                  rows={3}
                  placeholder="Enter event description"
                  required
                />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <FaCalendarAlt className="me-2 text-primary" />
                      Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={newEvent.date}
                      onChange={handleInputChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <FaMoneyBillWave className="me-2 text-success" />
                      Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={newEvent.amount}
                      onChange={handleInputChange}
                      placeholder="Enter amount"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>
                  <FaMapMarkerAlt className="me-2 text-danger" />
                  Location
                </Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  value={newEvent.location}
                  onChange={handleInputChange}
                  placeholder="Enter event location"
                  required
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button 
                type="submit" 
                variant={isEditMode ? "warning" : "success"}
              >
                {isEditMode ? "Update Event" : "Add Event"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </Container>
    </div>
  );
};

export default EventPage;